import { Link } from "react-router-dom";
import SignUpForm from "./SignUpForm";

const SignUp = () => (
  <main
    className="signup-page"
    style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/nebulox_login_bg.png)` }}
  >
    <div className="signup-card">
      <section className="signup-brand">
        <img
          src={`${process.env.PUBLIC_URL}/nebulox_logo_.png`}
          alt="Nebulox Parking"
        />
        <p>Únete a nuestra plataforma</p>
        <Link to="/login" className="signup-brand-login">
          Iniciar sesión
        </Link>
      </section>
      <SignUpForm />
    </div>
  </main>
);

export default SignUp;
